/* eslint no-nested-ternary: "off" */
/* eslint max-len: "off" */

import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import {
  setConfigString,
  setOrderRowDescription,
  setLanguage,
  setProductAttributes,
} from "../../store/addToCart/addToCartSlice";
import { setAlias } from "../../store/color/colorSlice";

import LfcCore from "../Core/LfcCore";

import PartPaymentInformation from "./PartPaymentInformation";
import InternalInfo from "./InternalInfo/InternalInfo";
import Pricehelper from "../../helpers/Pricehelper";
import determineLfcEnv from "../../helpers/determineLfcEnv";
import getUrlParameter from "../../helpers/getUrlParameter";
import setUrlParameter from "../../helpers/setUrlParameter";
import transformCgeToBfcProperties from "../../helpers/transformCgeToBfcProperties";
import removePanelDataItems from "../../helpers/removePanelDataItems";
import requestValuesByConfigString from "../../api/requestValuesByConfigString";
import postConfigProductOrderrow from "../../api/postConfigProductOrderrow";
import getProductPreset from "../../api/getProductPreset";
import langJson from "../../data/lang.json";
import LfcPreview from "./LfcPreview";
import PriceContainer from "./PriceContainer";

import { LfcWrapper, ProductInfoWrapper } from "./LfcContainer.styles";
import AddToCartSection from "./AddToCartSection";

const LFC_BACKEND_TEST_URL = process.env.REACT_APP_LFC_BACKEND_TEST_URL;
const LFC_BACKEND_LIVE_URL = process.env.REACT_APP_LFC_BACKEND_LIVE_URL;

class LfcContainerContent extends React.Component {
  constructor(props) {
    super(props);

    const language = this.getLanguage(this.props.channelId);

    this.state = {
      lfcEnv: determineLfcEnv(process.env.NODE_ENV),
      language: language,
      defaultValues: this.getDefaultValues(),
      dimsHiddenFromMarkets: null,
      pageHasDiscountTag:
        document.getElementsByClassName("p-save-percent").length > 0,
      pageArticlesNotAvailableTextHtml: document.getElementById(
        "lfcArticlesNotAvailableContainer"
      )
        ? document.getElementById("lfcArticlesNotAvailableContainer").innerHTML
        : null,
      pageStaticProductSpecs:
        document.getElementsByClassName("product-specs").length > 0
          ? document.getElementsByClassName("product-specs")[0]
          : null,
      pageDefaultPusherImageSrc: document.getElementById("product-pusher-image")
        ? document.getElementById("product-pusher-image").getAttribute("src")
        : null,
      pageArticleTitleLong:
        (document.getElementsByClassName("h2-produkt")[0] && // if this element is found in the document
          document.getElementsByClassName("h2-produkt")[0].innerHTML) || // then set titleLong to the content of that element
        "", // else set titleLong to empty string
      pageCampaignTextHtml:
        (document.getElementById("lfcCampaignTextContainer") && // if this element is found in the document
          document.getElementById("lfcCampaignTextContainer").innerHTML) || // then set pageCampaignTextHtml to the innerHTML of that element
        null, // else set pageCampaignTextHtml to null
      formatedM2: null,
      hasResult: false,
      configResult: null,
      articles: null,
      configQuantity:
        this.props.lfcMode === "WDW" || this.props.lfcMode === "DOOR"
          ? 1
          : null,
      isBuyable: true,
      totalRedPrice: null,
      totalBlackPrice: null,
      totalSave: null,
      deliveryInformation: this.props.deliveryInformation || null,
      deliveryStatus: this.props.deliveryStatus || null,
      messages: {},
      noppePriceHelper: null,
      lfcUpdateInProgress: false,
      generalError: false,
      postConfigProductOrderrowStatus: "",
      discounts: [],
      formattedPrice: "",
      previewImageDefaultHanding: true,
    };
  }

  componentWillMount() {
    this.setState({
      messages: langJson[this.state.language],
      noppePriceHelper: new Pricehelper(
        this.getApiBaseUrl(this.props.channelId)
      ),
    });
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.componentCleanup);

    this.props.setLanguage(this.state.language);

    const { lfcMode, runMode, panelConfigString, context } = this.props;
    const { lfcEnv } = this.state;

    // Store aliases needed for Lfc-doors, ColorPicker component, in redux store
    this.props.setAlias({
      labelChooseYourOwnColor: this.props.labelChooseYourOwnColor,
      ralColorNotFound: this.props.ralColorNotFound,
    });

    const onSuccess = (values) => {
      this.setState(() => ({
        defaultValues: values,
      }));
    };

    const onError = (error) => {
      this.setState(
        () => ({
          generalError: true,
        }),
        () => {
          console.error(
            "LfcContainer, error on requestValuesByConfigString:",
            JSON.stringify(error)
          );
        }
      );
    };

    const baseRestUrl =
      lfcEnv === "test" ? LFC_BACKEND_TEST_URL : LFC_BACKEND_LIVE_URL;

    // If started via LFC Panel with an existing config string,
    // request (default) values by config string
    if (
      (lfcMode === "WDW" || lfcMode === "DOOR") &&
      runMode === "panel" &&
      panelConfigString
    ) {
      requestValuesByConfigString(
        baseRestUrl,
        context,
        panelConfigString,
        onSuccess,
        onError
      );
    } else if (!this.props.defaultValues) {
      // Try to get DEFAULT preset
      getProductPreset(
        baseRestUrl,
        "SE-SKBV",
        context,
        "DEFAULT",
        true,
        onSuccess,
        onError
      );
    }
  }

  componentDidUpdate() {
    window.ColorBoxinline(); // adds event listener for delivery information lightbox link
  }

  componentWillUnmount() {
    this.componentCleanup();

    window.removeEventListener("beforeunload", this.componentCleanup);
  }

  componentCleanup = () => {
    removePanelDataItems();
  };

  checkJson = (str) => {
    try {
      JSON.parse(str);
    } catch (err) {
      return false;
    }
    return true;
  };

  getApiBaseUrl = (chId) => {
    const channelId = chId.toString();
    const nodeEnv = process.env.NODE_ENV;
    const { protocol, hostname, href } = window.location;
    let apiBaseUrl = null;

    if (nodeEnv === "development" || nodeEnv === "test") {
      // if node dev or test environment
      apiBaseUrl =
        process.env[`REACT_APP_SCENSUM_BASE_URL_TEST_ENV_CH_ID_${channelId}`];
      console.log(
        "lfc-frontend: Using apiBaseUrl for node development env: ",
        apiBaseUrl
      );
    } else if (href.toLowerCase().indexOf("nopperoyal.public") > -1) {
      // if local .NET environment
      apiBaseUrl = `${protocol}//${hostname}/NoppeRoyal.Public`;
      console.log(
        "lfc-frontend: Using apiBaseUrl for local .NET env: ",
        apiBaseUrl
      );
    } else if (hostname.indexOf("skbygg.com") > -1) {
      // else if test environment(s)
      const channelPath = this.getChannelPath(channelId);
      apiBaseUrl = `${protocol}//${hostname}${channelPath}`;
      console.log("lfc-frontend: Using apiBaseUrl for test env: ", apiBaseUrl);
    } else if (channelId === "1") {
      // else if SKBV or BM prod environment (BM is to be run as SKBV during test period)
      apiBaseUrl = "https://www.skanskabyggvaror.se";
    } else if (channelId === "2") {
      // Byggmax ByMe
      apiBaseUrl = "https://www.byme.byggmax.se";
    } else if (channelId === "4") {
      // else if GF prod environment
      apiBaseUrl = "https://www.grontfokus.no";
    } else if (channelId === "7" || channelId === "8") {
      // else if NR prod environment
      const channelPath = this.getChannelPath(channelId);
      apiBaseUrl = `https://www.nordrum.com${channelPath}`;
    } else if (channelId === "9") {
      apiBaseUrl = `https://www.byme.byggmax.no`;
    }

    return apiBaseUrl;
  };

  getChannelPath = (chId) => {
    const channelId = chId.toString();

    let channelPath = "";

    if (channelId === "7") {
      channelPath = "/fi/sv";
    } else if (channelId === "8") {
      channelPath = "/fi/fi";
    }

    return channelPath;
  };

  getDefaultValues = () => {
    const { lfcMode, runMode, panelConfigString, defaultValues } = this.props;

    // If started via LFC Panel with an existing config string,
    // return null
    // and proceed with request for values by config string when component did mount
    if (
      (lfcMode === "WDW" || lfcMode === "DOOR") &&
      runMode === "panel" &&
      panelConfigString
    ) {
      return null;
    }

    const chosenValuesFromUrl = getUrlParameter("chosenValues");

    // If values are present from URL parameter, use them as default values
    if (chosenValuesFromUrl && this.checkJson(`[${chosenValuesFromUrl}]`)) {
      return JSON.parse(`[${chosenValuesFromUrl}]`);
    } else if (defaultValues) {
      return defaultValues;
    } else return null; // Handle it in componentDidMount to prevent async-issues
  };

  // Returns language code (ISO 639-1)
  getLanguage = (channelId) => {
    switch (channelId.toString()) {
      case "1":
      case "2":
      case "7":
        return "sv";
      case "4":
      case "9":
        return "no";
      case "8":
        return "fi";
      default:
        return null;
    }
  };

  setChosenValues = (newValues) => {
    const str = JSON.stringify(newValues);
    const parameterValue = str.slice(1, str.length - 1);

    setUrlParameter("chosenValues", parameterValue);
  };

  lfcUpdateInProgress = (isUpdating) => {
    this.setState({
      lfcUpdateInProgress: isUpdating,
    });
  };

  updateDiscountTag = () => {
    if (this.state.pageHasDiscountTag) {
      const displayLimit = 0.1; // 10%

      // Calculate discount percentage, the variable name differs depending on product type
      // WDW/DOOR = totalSave, Partout = productDiscount
      // round up to prevent discounts like 9.999999999999996% from hiding the tag
      const percent =
        this.props.lfcMode === "WDW" || this.props.lfcMode === "DOOR"
          ? Math.ceil((this.state.totalSave / this.state.totalBlackPrice) * 100)
          : Math.ceil(
              (this.state.productDiscount / this.state.totalBlackPrice) * 100
            );

      // Leave discount tag if there is a discounts array
      if (this.state.discounts.length > 0) return;

      // If discount percentage is less than display limit (10%), hide it
      if (percent < displayLimit) {
        document.getElementsByClassName("p-save-percent")[0].style.display =
          "none";
      }
    }
  };

  updateProductSpecs = () => {
    const { pageStaticProductSpecs } = this.state;

    if (pageStaticProductSpecs) {
      const configProduct = this.state.configResult.configProducts[0]; // good enough for first delivery POC
      const { attributes } = configProduct.editorial;

      const prevProductSpecs =
        document.getElementsByClassName("product-properties")[0]
          .firstElementChild;
      const newProductSpecs = pageStaticProductSpecs.cloneNode(true);

      // if there are attributes, modify the new product specs
      if (attributes.length > 0) {
        const tableRows = attributes.map((attribute) => {
          const tr = document.createElement("tr");

          const td1 = document.createElement("td");
          td1.appendChild(document.createTextNode(attribute.attributeName));

          const td2 = document.createElement("td");
          td2.appendChild(document.createTextNode(attribute.attributeValue));

          tr.appendChild(td1);
          tr.appendChild(td2);

          return tr;
        });

        tableRows.reverse().forEach((row) => {
          const tbody = newProductSpecs.firstElementChild;
          const currentFirstChild = tbody.firstElementChild;

          tbody.insertBefore(row, currentFirstChild);
        });
      }

      document
        .getElementsByClassName("product-properties")[0]
        .replaceChild(newProductSpecs, prevProductSpecs);
    }
  };

  updateArticleTitleLong = () => {
    const { formatedM2, pageArticleTitleLong } = this.state;
    const articleTitleLong = document.querySelector(".h2-produkt");

    if (articleTitleLong && formatedM2) {
      articleTitleLong.innerHTML = `<strong>${formatedM2} m<sup>2</sup></strong> &ndash; ${pageArticleTitleLong}`;
    }
  };

  handleResult = (result, properties, selectedValues) => {
    const handleConfigResult = (configResult, selectedValues) => {
      const configProduct = configResult.configProducts[0]; // good enough for first delivery POC
      const {
        editorial,
        price,
        ordinaryPrice,
        configString,
        orderRowDescription,
      } = configProduct;
      this.props.setConfigString(configString);
      this.props.setOrderRowDescription(orderRowDescription);

      const { images, attributes, dimsHiddenFromMarkets } = editorial;
      this.props.setProductAttributes(attributes);

      const imageId = images.length ? images[0].imageId : "";
      const totalRedPrice = price;
      const totalBlackPrice = ordinaryPrice;

      this.setState(
        {
          hasResult: true,
          configResult: {
            ...configResult,
            chosenValues: selectedValues,
          },
          totalRedPrice,
          totalBlackPrice,
          totalSave: totalBlackPrice - totalRedPrice,
          lfcUpdateInProgress: false,
          imageId: imageId,
          dimsHiddenFromMarkets: dimsHiddenFromMarkets,
        },
        () => {
          this.setChosenValues(selectedValues);
          this.updateDiscountTag();
          this.updateProductSpecs();
        }
      );

      // TODO: FIX THIS

      this.updateConfigQuantity(this.state.configQuantity);
    };

    const handlePartoutResult = (bundle, properties, selectedValues) => {
      const { articles, summary } = bundle;

      if (!articles || !summary) return;

      const totalRedPrice = summary.Price;
      const totalBlackPrice = summary.OrdinaryPrice;
      const deliveryInformation = summary.DeliveryInformation;
      const deliveryStatus = summary.DeliveryStatus;
      const productDiscount = summary.ProductDiscount; // this is the discount of the individual products (i.e. the parts of an uterum) added together
      const discounts = summary.Discounts; // this is an array of campaigns with their corresponding data
      const formattedPrice = summary.FormatedPrice; // Pre-formatted from the backend

      const { m2, metaInfo } = properties;
      const formatedM2 = m2 ? m2.replace(".", ",") : null;
      const cgeProperties = metaInfo ? metaInfo.cgeProperties : null;

      // here we add the product discounts and campaign discounts together
      let totalSave = productDiscount;
      discounts.forEach((discount) => {
        totalSave += discount.Discount;
      });

      this.setState(
        {
          formatedM2,
          cgeProperties,
          hasResult: true,
          articles,
          isBuyable: true,
          totalRedPrice,
          totalBlackPrice,
          totalSave: totalSave,
          deliveryInformation,
          deliveryStatus,
          lfcUpdateInProgress: false,
          productDiscount,
          discounts,
          formattedPrice,
        },
        () => {
          this.setChosenValues(selectedValues);
          this.updateDiscountTag();
          // this.updatePusherImage();
          this.updateArticleTitleLong();
        }
      );
    };

    // lfcMode is only available for Window and Door. If missing app is run in default mode
    this.props.lfcMode === "WDW" || this.props.lfcMode === "DOOR"
      ? handleConfigResult(result, selectedValues)
      : handlePartoutResult(result, properties, selectedValues);
  };

  updateConfigQuantity = (newQuantity) => {
    if (this.props.lfcMode === "WDW" || this.props.lfcMode === "DOOR") {
      const currentProductData = this.state.configResult.configProducts[0];

      const articlesData = [
        {
          sku: currentProductData.prodNo,
          qty: newQuantity,
          overridePricing: currentProductData.pricingInfo,
        },
      ];

      this.state.noppePriceHelper
        .getPriceHelperOverridePrice(articlesData)
        .then((priceHelperData) => {
          const totalRedPrice = priceHelperData.summary.Price;
          const totalBlackPrice = priceHelperData.summary.OrdinaryPrice;
          const productDiscount = priceHelperData.summary.ProductDiscount; // this is the discount of the individual products (i.e. the parts of an uterum) added together
          const discounts = priceHelperData.summary.Discounts; // this is an array of campaigns with their corresponding data
          const formattedPrice = priceHelperData.summary.FormatedPrice; // Pre-formatted from the backend

          // here we add the product discounts and campaign discounts together
          let totalSave = productDiscount;
          discounts.forEach((discount) => {
            totalSave += discount.Discount;
          });

          this.setState(() => ({
            totalRedPrice: totalRedPrice,
            totalBlackPrice: totalBlackPrice,
            totalSave: totalSave,
            productDiscount: productDiscount,
            discounts: discounts,
            formattedPrice: formattedPrice,
            configQuantity: newQuantity,
          }));
        });
    } else {
      this.setState(() => ({
        configQuantity: newQuantity,
      }));
    }
  };

  sendToJeeves = () => {
    const { lfcMode, runMode, panelToken, panelSessionId, colorUnique } =
      this.props;
    const { lfcEnv, configResult, postConfigProductOrderrowStatus } =
      this.state;
    const {
      configString,
      orderRowDescription,
      purchasePrice,
      ordinaryPrice,
      price,
      prodNo,
      weightVolumeDimensions,
    } = configResult.configProducts[0];

    if (!panelToken || !panelSessionId) {
      this.setState(
        () => ({
          generalError: true,
        }),
        () => {
          console.error(
            "LfcContainer, LFC Panel token OR sessionID is missing"
          );
        }
      );
    }

    if (postConfigProductOrderrowStatus === "success") {
      alert(
        "-- NOTE --\nUpdate for order row information has already been sent to Jeeves!\nPlease review the order row in Jeeves.\nDo not forget to close this browser tab."
      );

      return;
    }

    let newConfigString = configString;
    let newOrderRowDescription = orderRowDescription;
    if (this.props.colorDimensions.length && configString.length) {
      newConfigString = colorUnique
        ? configString.replace("OPTIONAL_COLOR", colorUnique)
        : configString;

      const optionalColorDimensionValueProps =
        this.props.colorDimensions[0].values.filter(
          (value) => value.factoryValueCode === "OPTIONAL_COLOR"
        );

      const optionalColorValueName = () => {
        switch (this.state.language) {
          case "sv":
            return optionalColorDimensionValueProps[0].valueNameSE;
          case "no":
            return optionalColorDimensionValueProps[0].valueNameNO;
          case "fi":
            return optionalColorDimensionValueProps[0].valueNameFI;
          default:
            return optionalColorDimensionValueProps[0].valueNameEN;
        }
      };

      newOrderRowDescription = colorUnique
        ? orderRowDescription.replace(optionalColorValueName(), colorUnique)
        : orderRowDescription;
    }

    if (
      (lfcMode === "WDW" || lfcMode === "DOOR") &&
      runMode === "panel" &&
      panelToken &&
      panelSessionId
    ) {
      // Add an extra check
      // panelToken och panelSessionId kommer ursprungligen från Jeeves via Scensum
      const env = lfcEnv;
      const sessionId = panelSessionId;
      const apiKey = panelToken;
      const body = {
        ConfigString: newConfigString,
        OrderRowDescription: newOrderRowDescription,
        PurchasePrice: purchasePrice,
        OrdinaryPrice: ordinaryPrice,
        Price: price,
        Sku: prodNo,
        // Todo, make this easier...
        WeightVolumeDimensions: weightVolumeDimensions
          ? {
              WeightInKg:
                weightVolumeDimensions.weightInKg ||
                weightVolumeDimensions.weightInKg === 0
                  ? weightVolumeDimensions.weightInKg
                  : null,
              WidthInMeters:
                weightVolumeDimensions.widthInMeters ||
                weightVolumeDimensions.widthInMeters === 0
                  ? weightVolumeDimensions.widthInMeters
                  : null,
              DepthInMeters:
                weightVolumeDimensions.depthInMeters ||
                weightVolumeDimensions.depthInMeters === 0
                  ? weightVolumeDimensions.depthInMeters
                  : null,
              HeightInMeters:
                weightVolumeDimensions.heightInMeters ||
                weightVolumeDimensions.heightInMeters === 0
                  ? weightVolumeDimensions.heightInMeters
                  : null,
              FreightVolumeCategory:
                weightVolumeDimensions.freightVolumeCategory || null,
            }
          : null,
      };

      const onSuccess = () => {
        this.setState(
          () => ({
            postConfigProductOrderrowStatus: "success",
          }),
          () => {
            alert(
              "Sending order row information to Jeeves...\nDo not forget to close this browser tab."
            );
          }
        );
      };

      const onError = (error) => {
        this.setState(
          () => ({
            postConfigProductOrderrowStatus: "error",
          }),
          () => {
            console.error(
              "LfcContainer, error sendToJeeves:",
              JSON.stringify(error)
            );
            alert("-- ERROR --\nOrder row information was NOT sent to Jeeves!");
          }
        );
      };

      this.setState(
        () => ({
          postConfigProductOrderrowStatus: "pending",
        }),
        () => {
          postConfigProductOrderrow(
            env,
            sessionId,
            apiKey,
            body,
            onSuccess,
            onError
          );
        }
      );
    }
  };

  lfcError = (error) => {
    console.error(`LfcContainer: ${JSON.stringify(error)}`);

    if (error.type === "generalError") {
      this.setState({
        generalError: true,
      });
    }
  };

  formatPrice = (chId, number) => {
    const channelId = chId.toString();

    // Returns format 1.234 kr for SEK/NOK
    if (
      channelId === "1" ||
      channelId === "2" ||
      channelId === "4" ||
      channelId === "9"
    ) {
      return `${Math.floor(number).toLocaleString("it-IT", {
        style: "decimal",
      })} kr`;
    }

    // Returns format 1 234 € for EUR
    if (channelId === "7" || channelId === "8") {
      const locale = channelId === "7" ? "sv-FI" : "fi-FI";

      return Math.floor(number).toLocaleString(locale, {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 0,
      });
    }

    return null;
  };

  calcCollectorAmount = () => {
    const totalPrice =
      this.state.totalSave > 0
        ? this.state.totalRedPrice
        : this.state.totalBlackPrice;

    return totalPrice * 100;
  };

  renderDeliveryInformation = () => {
    const { channelId, deliveryLinktext } = this.props;
    const { deliveryInformation, deliveryStatus } = this.state;

    let deliveryIcon = (
      <img
        className="product-usp-img"
        alt="delivery-icon"
        src="https://s.skbv.se/assets/icons/usp-green.svg"
      />
    ); // InStock, default icon
    if (deliveryStatus.trim() === "ItemOnway") {
      deliveryIcon = <i className="fas fa-truck fa-lg" aria-hidden="true"></i>;
    } else if (deliveryStatus.trim() === "ProductionItem") {
      deliveryIcon = <i className="fas fa-tools" aria-hidden="true"></i>;
    }

    const renderDeliveryLink = () => {
      let href = null;

      if (channelId.toString() === "1") {
        href = "/kopvillkor#leverans";
      }

      if (channelId.toString() === "2") {
        href = "/kundtjanst/kopvillkor#leverans";
      }

      if (channelId.toString() === "4") {
        href = "/salgvilkar#anchor2";
      }

      if (channelId.toString() === "7") {
        href = "/fi/sv/kundservice/leveransinformation/";
      }

      if (channelId.toString() === "8") {
        href = "/fi/fi/asiakaspalvelu/tietoa-toimituksistamme/";
      }

      if (channelId.toString() === "9") {
        href = "/kundeservice/leveringsinformasjon/";
      }

      return href && deliveryLinktext ? (
        <a
          href={href}
          className="a-green"
          target="_blank"
          rel="noopener noreferrer"
        >
          {deliveryLinktext}
        </a>
      ) : null;
    };

    return (
      <p className="buy-form-delivery-information">
        <span className="icon-container">{deliveryIcon}</span>
        <span>
          {deliveryInformation} {renderDeliveryLink()}
        </span>
      </p>
    );
  };

  renderArticleInStoreInfo = () => {
    const { articleInStoreInfotext, articleInStoreLinktext } = this.props;

    if (articleInStoreInfotext && articleInStoreLinktext) {
      return (
        <p className="buy-form-store">
          <span className="icon-container">
            <i className="fas fa-map-marked-alt fa-lg" aria-hidden="true"></i>
          </span>
          <span>
            {`${articleInStoreInfotext} `}
            <a
              className="a-green"
              href="#anchortabs"
              onClick={() => {
                const allAccordionsAndTabs =
                  document.querySelectorAll(".state");

                allAccordionsAndTabs.forEach((element) => {
                  element.removeAttribute("checked");
                });

                const accordion = document.querySelector(
                  "#accordion-productavailability"
                );
                const tab = document.querySelector("#tab-productavailability");

                // open the accordion/tab with product availability information
                [accordion, tab].forEach((element) => {
                  if (element) {
                    element.checked = true;
                  }
                });
              }}
            >
              {articleInStoreLinktext}
            </a>
          </span>
        </p>
      );
    }

    return null;
  };

  renderHtml = (DOMString) => (
    <div
      dangerouslySetInnerHTML={{
        __html: DOMString,
      }}
    />
  );

  renderBfcBanner = () => {
    const { channelId, aliasContinueWithBfcInfo, aliasContinueWithBfcLink } =
      this.props;

    if (!aliasContinueWithBfcInfo || !aliasContinueWithBfcLink) {
      return null;
    }

    const { cgeProperties } = this.state;

    if (cgeProperties && Object.keys(cgeProperties).length > 0) {
      const bfcProperties = transformCgeToBfcProperties(cgeProperties);

      if (bfcProperties && Object.keys(bfcProperties).length > 0) {
        const bfcParams = Object.keys(bfcProperties)
          .map(
            (property) =>
              `${encodeURIComponent(property)}=${encodeURIComponent(
                bfcProperties[property]
              )}`
          )
          .join("&");

        const channelPath = this.getChannelPath(channelId);

        return (
          <div className="lfc-continue-with-bfc">
            <span className="bfc-info">
              <i className="fas fa-tools fa-lg"></i>
              {aliasContinueWithBfcInfo}
            </span>
            <a
              className="bfc-link"
              href={`${channelPath}/cguide/step4?${bfcParams}`}
            >
              {aliasContinueWithBfcLink}
            </a>
          </div>
        );
      }
    }
  };

  renderSkulist = () => (
    <div className="lfc-skulist-container">
      <div className="lfc-skulist-header">
        {this.state.messages.bundleContains}
      </div>
      <ul className="lfc-skulist">
        {this.state.articles.map((item) => (
          <li key={item.Sku} className="lfc-skulist-item">
            <div className="lfc-skulist-qty">
              {item.Quantity} {this.state.messages.pcs}
            </div>
            <div className="lfc-skulist-title">
              {item.Title || item.TitleLong ? (
                `${item.Title} ${item.TitleLong}`
              ) : (
                <em>{this.state.messages.articleTitleIsMissing}</em>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );

  handleHandingChange = () => {
    this.setState({
      previewImageDefaultHanding: !this.state.previewImageDefaultHanding,
    });
  };

  render() {
    // These props are passed from Scensum backend through data-this.props, using react-habitat
    const {
      channelId,
      context,
      productTitle,
      productTitleLong,
      lfcMode,
      imageBaseUrl,
      pusherImageUrl,
      runMode,
      pricingInfo,
      freeShippingInfotext,
      articleInStoreInfotext,
      articleInStoreLinktext,
      manufacturingarticleTagText,
      manufacturingarticleInformation,
      userType,
      walleyWidgetToken,
      walleyWidgetSrc,
      minPartpayment,
      maxPartpayment,
      aliasPartPaymentInformation,
      thirtyDayLowestInfo,
      priceInfo,
    } = this.props;

    const {
      lfcEnv,
      defaultValues,
      generalError,
      messages,
      language,
      noppePriceHelper,
      hasResult,
      lfcUpdateInProgress,
      cgeProperties,
      pageCampaignTextHtml,
      configQuantity,
      deliveryInformation,
      configResult,
      isBuyable,
      pageArticlesNotAvailableTextHtml,
    } = this.state;

    const isPanel =
      (lfcMode === "WDW" || lfcMode === "DOOR") && runMode === "panel";

    const priceWithinLimits =
      this.state.totalRedPrice >= minPartpayment / 100 &&
      this.state.totalRedPrice <= maxPartpayment / 100;
    const availableForPartPayment =
      priceWithinLimits && walleyWidgetToken && walleyWidgetSrc;

    if (!context || generalError) {
      return <div className="lfc-general-error">{messages.generalError}</div>;
    }

    if (!defaultValues) {
      return <div className="lfc-loader" />;
    }

    return (
      <LfcWrapper>
        {lfcMode === "DOOR" && (
          <LfcPreview
            imageId={this.state.imageId}
            imageBaseUrl={imageBaseUrl}
            pusherImageUrl={pusherImageUrl}
            assetBaseUrl={this.props.assetBaseUrl}
            language={this.state.language}
            updatingDimensions={!hasResult || lfcUpdateInProgress}
            previewImageDefaultHanding={this.state.previewImageDefaultHanding}
          />
        )}

        <ProductInfoWrapper>
          {productTitle && <h1>{productTitle}</h1>}
          {productTitleLong && (
            <div className="title-long-and-ratings">
              <h2 className="h2-produkt">{productTitleLong}</h2>
            </div>
          )}

          <LfcCore
            env={lfcEnv}
            lfcMode={lfcMode}
            context={context}
            language={language} // ISO 639-1
            channelId={channelId}
            messages={messages}
            defaultValues={defaultValues}
            dimsHiddenFromMarkets={this.state.dimsHiddenFromMarkets}
            priceHelper={
              lfcMode === "WDW" || lfcMode === "DOOR"
                ? null
                : noppePriceHelper.getPricesForSkus
            }
            pricingInfo={pricingInfo} // only used for WDW, will be null for CVY
            onChange={this.handleResult}
            updateInProgress={this.lfcUpdateInProgress}
            onError={this.lfcError}
            renderDimensionDescriptions
            handleHandingChange={this.handleHandingChange}
          />

          {!hasResult || lfcUpdateInProgress ? (
            <div className="lfc-loader" />
          ) : (
            <React.Fragment>
              {cgeProperties && this.renderBfcBanner()}

              {pageCampaignTextHtml && this.renderHtml(pageCampaignTextHtml)}

              {lfcMode !== "WDW" && lfcMode !== "DOOR" && this.renderSkulist()}

              <PriceContainer
                channelId={this.props.channelId}
                messages={this.state.messages}
                totalSave={this.state.totalSave}
                totalBlackPrice={this.state.totalBlackPrice}
                totalRedPrice={this.state.totalRedPrice}
                discounts={this.state.discounts}
                formattedPrice={this.state.formattedPrice}
                productDiscount={this.state.productDiscount}
                formatPrice={this.formatPrice}
                thirtyDayLowestInfo={thirtyDayLowestInfo}
                priceInfo={priceInfo}
              />

              {availableForPartPayment && (
                <PartPaymentInformation
                  walleyWidgetToken={walleyWidgetToken}
                  walleyWidgetSrc={walleyWidgetSrc}
                  aliasPartPaymentInformation={aliasPartPaymentInformation}
                  amount={this.calcCollectorAmount()}
                  channelId={channelId}
                />
              )}

              <AddToCartSection
                lfcMode={lfcMode}
                isPanel={isPanel}
                messages={messages}
                configQuantity={configQuantity}
                updateConfigQuantity={this.updateConfigQuantity}
                sendToJeeves={this.sendToJeeves}
                context={this.props.context}
                imageBaseUrl={this.props.imageBaseUrl}
                erpItemNumber={this.props.erpItemNumber}
                channelId={this.props.channelId}
                loop54EventBaseUrl={this.props.loop54EventBaseUrl}
                productId={this.props.productId}
                configResult={this.state.configResult}
                articles={this.state.articles}
                getApiBaseUrl={this.getApiBaseUrl}
              />

              {!isBuyable &&
                pageArticlesNotAvailableTextHtml &&
                this.renderHtml(pageArticlesNotAvailableTextHtml)}

              {isBuyable &&
                deliveryInformation &&
                this.renderDeliveryInformation()}

              {isBuyable && freeShippingInfotext && (
                <div className="buy-form-free-shipping">
                  <span className="icon-container">
                    <span className="fas fa-truck fa-lg"></span>
                  </span>
                  <span className="free-shipping">{freeShippingInfotext}</span>
                </div>
              )}

              {/* {this.state.totalSave > 0 ? (
                <p className="buy-form-30-day-lp">{thirtyDayLowestInfo}</p>
              ) : (
                ""
              )} */}

              {articleInStoreInfotext &&
                articleInStoreLinktext &&
                this.renderArticleInStoreInfo()}

              {manufacturingarticleTagText &&
                manufacturingarticleInformation && (
                  <p className="buy-form-manufacturing-article">
                    <span className="buy-form-tag">
                      {manufacturingarticleTagText}
                    </span>
                    <span className="buy-form-tag-description">
                      {manufacturingarticleInformation}
                    </span>
                  </p>
                )}

              {this.props.hemfixarId?.length ? (
                <hemfixarna-skanska
                  id={this.props.hemfixarId}
                  className="hydrated"
                ></hemfixarna-skanska>
              ) : (
                ""
              )}

              {(lfcMode === "WDW" || lfcMode === "DOOR") &&
                userType === "store" && (
                  <InternalInfo configResult={configResult} />
                )}
            </React.Fragment>
          )}
        </ProductInfoWrapper>
      </LfcWrapper>
    );
  }
}

LfcContainerContent.propTypes = {
  assetBaseUrl: PropTypes.string.isRequired,
  erpItemNumber: PropTypes.string.isRequired,
  loop54EventBaseUrl: PropTypes.string.isRequired,
  manufacturingarticleInformation: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  runMode: PropTypes.string.isRequired,
  pricingInfo: PropTypes.string,
  lfcMode: PropTypes.string,
  imageBaseUrl: PropTypes.string,
  pusherImageUrl: PropTypes.string,
  articleInStoreInfotext: PropTypes.string,
  articleInStoreLinktext: PropTypes.string,
  channelId: PropTypes.string,
  context: PropTypes.string,
  defaultValues: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.string,
  ]),
  deliveryInformation: PropTypes.string,
  deliveryLinktext: PropTypes.string,
  freeShippingInfotext: PropTypes.string,
  manufacturingarticleTagText: PropTypes.string,
  productTitle: PropTypes.string,
  productTitleLong: PropTypes.string,
  labelChooseYourOwnColor: PropTypes.string,
  ralColorNotFound: PropTypes.string,
  hemfixarId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  configString: state.addToCart.configString,
  orderRowDescription: state.addToCart.orderRowDescription,
  productAttributes: state.addToCart.productAttributes,
  language: state.addToCart.language,
  color: state.color.color,
  colorUnique: state.color.colorUnique,
  validUserColor: state.color.validUserColor,
  colorDimensions: state.dimensions.colorDimensions,
});

const mapDispatchToProps = {
  setConfigString,
  setOrderRowDescription,
  setAlias,
  setLanguage,
  setProductAttributes,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LfcContainerContent);
